import type { Database } from '@/entities/database';
import request from '@/shared/api/request';

export const createDatabase = (data: {
  name: string;
  engine: string;
  region: string;
  size: string;
  project_uuid?: string;
  tags: string[];
}): Promise<{ database: Database }> =>
  request({
    url: '/databases/',
    method: 'POST',
    data,
  });
